import React from "react";
import { api } from "@/lib/api";

export const eur = (v, d = 2) => (v == null ? "—" : `€ ${Number(v).toFixed(d)}`);
export const num = (v, d = 2) => (v == null || Number.isNaN(Number(v)) ? "—" : Number(v).toFixed(d));
export const artifactUrl = (name) => `${api.defaults.baseURL}/beta03/artifacts/${name}`;

export const OUTCOME_META = {
  AUTOMATIC: { label: "Automatico", cls: "bg-ok-100 text-ok-800 border-ok-300" },
  ASSISTED: { label: "Assistito", cls: "bg-tech-100 text-tech-800 border-tech-300" },
  MANUAL: { label: "Manuale", cls: "bg-warn-100 text-warn-800 border-warn-300" },
  NOT_COMPUTABLE: { label: "Bloccato", cls: "bg-risk-100 text-risk-800 border-risk-300" },
};

export const Badge = ({ outcome, testId }) => {
  const m = OUTCOME_META[outcome] || { label: outcome || "—", cls: "bg-muted" };
  return <span className={`inline-block px-1.5 py-0.5 border rounded-sm text-[9px] font-bold uppercase whitespace-nowrap ${m.cls}`} data-testid={testId}>{m.label}</span>;
};

export const Card = ({ title, subtitle, children, testId, tone = "border-border" }) => (
  <section className={`border ${tone} bg-white rounded-md shadow-sm`} data-testid={testId}>
    <header className="px-3 py-2 border-b border-border bg-ivory"><div className="text-sm font-black tracking-tight">{title}</div>{subtitle && <div className="text-[10px] text-muted-foreground">{subtitle}</div>}</header>
    <div className="p-3 text-[11px] space-y-2">{children}</div>
  </section>
);

export const KV = ({ k, v, testId }) => <div className="flex justify-between gap-3 border-b border-border/50 py-0.5"><span className="text-muted-foreground">{k}</span><span className="font-mono text-right" data-testid={testId}>{v}</span></div>;

export const ExtLink = ({ href, children, testId }) => <a className="link-tech font-bold hover:underline" href={href} target="_blank" rel="noreferrer" data-testid={testId}>{children}</a>;
